import React, { useState } from "react";
import Select from 'react-select';

const SelectDropDown = ({options, placeholder, className, classNamePrefix, handleChange, selectedValue, menuIsOpen}) => {

    return (
        <Select options={options}
            placeholder={selectedValue ? selectedValue : placeholder} 
            className={className}
            classNamePrefix={classNamePrefix}
            onChange={(e) => handleChange(e.value)}
            menuIsOpen={menuIsOpen}
            isSearchable={false}

        />
    );
};
export default SelectDropDown;